import { DateTime } from 'luxon'
import { appConfig } from '@rosetta-ai/web/src/models/app'
import { behavior } from '../stores'

const getAllQuantity = products => products.reduce((c, p) => c + p.quantity, 0)
const getAllTotal = products => products.reduce((c, p) => c + p.total, 0)

export const getEventPayload = ({
  action,
  target = null,
  details = null,
  provider = null,
  context = null,
  source = null,
  recommender = null,
  currency = null,
  value = null
}) => {
  let payload = {
    details,
    provider,
    context, // component ID
    source,
    recommender,
    ...(currency && { currency }),
    value
  }

  if (
    appConfig.inheritAttribution &&
    !provider &&
    target &&
    action !== 'click'
  ) {
    // click 以外的 events 才會繼承歸因
    const attributedActions = behavior.getHonor()
    const { details: attributedActionDetails, ...restAttributedAction } =
      attributedActions[target] || {}

    payload = {
      ...payload,
      ...restAttributedAction,
      ...((attributedActionDetails || details) && {
        details: { ...attributedActionDetails, ...details }
      })
    }
  } else if (action === 'order') {
    // order 的歸因統一在此處理
    const attributedActions = behavior.getHonor()
    let isHonor = false
    const { products, ...restDetails } = details
    let formattedProducts = products

    if (appConfig.inheritAttribution) {
      formattedProducts = products.map(product => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { action, target, details, ...attributedActionData } =
          attributedActions[product.target] || {}
        if (
          [product.provider, attributedActionData.provider].includes('rosetta')
        ) {
          isHonor = true
        }
        return { ...product, ...attributedActionData }
      })
    } else {
      isHonor = products.some(product => product.provider === 'rosetta')
    }

    const honorItems = formattedProducts.filter(p => p.provider === 'rosetta')

    payload = {
      ...payload,
      details: {
        ...restDetails,
        ...(formattedProducts.length
          ? {
              isHonor,
              products: formattedProducts,
              counts: {
                totalItems: formattedProducts.length,
                totalQuantity: getAllQuantity(formattedProducts),
                honorItems: honorItems.length,
                honorQuantity: getAllQuantity(honorItems)
              },
              totalFromProducts: getAllTotal(formattedProducts),
              totalFromHonorProducts: getAllTotal(honorItems)
            }
          : {})
      },
      provider: isHonor ? 'rosetta' : null
    }
  }

  return {
    ...payload,
    action,
    target,
    timestamp: Math.round(DateTime.now().toSeconds())
  }
}
